import {
  AssetWatchLogo,
  Button,
  Headline,
  Stack,
  Text,
} from "@assetwatch/ui";
import { lazy, Suspense } from "react";
import type { CustomLoginFormMessages } from "./CustomLoginForm";

const CelebrationGraphic = lazy(() =>
  import("./CelebrationGraphic").then((module) => ({
    default: module.CelebrationGraphic,
  })),
);

type AccountCreatedScreenProps = {
  isLoading: boolean;
  messages: CustomLoginFormMessages;
  onStartMonitoring: () => void;
};

export function AccountCreatedScreen({
  isLoading,
  messages,
  onStartMonitoring,
}: AccountCreatedScreenProps) {
  const startMonitoringLabel =
    messages.actions.startMonitoring ?? "Start monitoring";

  return (
    <>
      <Stack align="center" gap={16}>
        <AssetWatchLogo aria-hidden size="display" tone="default" />
        <Headline align="center" as="h1" size="sm">
          {messages.headings.accountCreatedTitle}
        </Headline>
        <div className="w-full max-w-[334px]">
          <Text align="center" tone="subtext">
            {messages.headings.accountCreatedDescription}
          </Text>
        </div>
      </Stack>
      <Stack align="center" gap={40}>
        <Suspense fallback={null}>
          <CelebrationGraphic size="xl" />
        </Suspense>
        <Button
          data-testid="start-monitoring-button"
          fullWidth
          loading={isLoading}
          loadingText={messages.loading.redirecting}
          type="button"
          onClick={onStartMonitoring}
        >
          {startMonitoringLabel}
        </Button>
      </Stack>
    </>
  );
}
